import { defineMessages } from '@transcend-io/internationalization';

export const confirmModalMessages = defineMessages(
  'ad-core-components.ConfirmModal.confirmModal',
  {
    heading: {
      defaultMessage: 'Confirmation Required',
    },
    content: {
      defaultMessage: 'Are you sure you want to do this?',
    },
  },
);
